export const USERMANAGEMENT_BANNER_HEIGHT = 64;
export const DEFAULT_TOPBAR_HEIGHT = 52;
